// Semantic tone tokens shared by the Home cards (light and dark themes).
export const HOME_TONES = {
  blue: 'bg-n-blue-3 text-n-blue-11',
  teal: 'bg-n-teal-3 text-n-teal-11',
  grass: 'bg-n-grass-3 text-n-grass-11',
  amber: 'bg-n-amber-3 text-n-amber-11',
  violet: 'bg-n-violet-3 text-n-violet-11',
  ruby: 'bg-n-ruby-3 text-n-ruby-11',
  slate: 'bg-n-slate-3 text-n-slate-11',
};

export const homeToneClass = tone => HOME_TONES[tone] || HOME_TONES.slate;

export const HOME_CARD_CLASS =
  'rounded-2xl border border-n-weak bg-n-solid-1 shadow-sm dark:border-n-strong';

const LINK_BASE =
  'inline-flex h-9 items-center justify-center gap-2 whitespace-nowrap rounded-lg px-3.5 text-sm font-medium transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-n-brand';

export const HOME_PRIMARY_LINK_CLASS = `${LINK_BASE} bg-n-brand text-white hover:brightness-110`;

export const HOME_SECONDARY_LINK_CLASS = `${LINK_BASE} border border-n-weak bg-n-solid-1 text-n-slate-12 hover:bg-n-alpha-2 dark:border-n-strong`;
